import { ElasticSearchService, ESExtras, EsFirestoreBase } from '@a2system/angular';
import { Injectable, Optional } from '@angular/core';
import { doc, DocumentReference, Firestore, serverTimestamp, setDoc } from '@angular/fire/firestore';
import { FileDbService } from 'admin/src/app/shared/a2-files/services/file-db.service';
import { addDoc, collection, increment } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { Installer } from '../models/installer.model';
import { getDownloadURL, getStorage, ref, uploadBytes, uploadString } from "@angular/fire/storage";

const ES_EXTRA:ESExtras = {
  status:{
    type:"term"
  },
}

const ES_SOURCE = null; //['status']

@Injectable({
  providedIn: 'root'
})
export class InstallerDsService extends EsFirestoreBase<Installer> {
  collectionName = 'installers';
  constructor(
    @Optional() protected firestore: Firestore,
    protected es: ElasticSearchService,
    private fileDbService: FileDbService,
  ){
    super(firestore, es, 'installers', ES_EXTRA, ES_SOURCE);
  }


  getAllSubCollection$(subPath:string): Observable<any[]>{
    return  this.fileDbService.getAll$(subPath).pipe(
      // tap(a => console.log({a}))
    )
  }

  upsert(_data, isNew=false): Promise<string> {
    const { id, ...data } = _data;
    let docRef: DocumentReference;
    data.updatedAt = serverTimestamp();
    data._version = increment(1);
    if(isNew || !id) {data.createdAt = serverTimestamp();}
    return id 
           ? setDoc(doc(this.collection, id), data, {merge:!(isNew || !id)}).then(()=> id)
           : addDoc(this.collection, data).then((dr)=> dr.id)
  }

  // constructor(
  //   protected db: AngularFirestore,
  //   protected es: ElasticSearchService,
  // ) {
  //   super(db,es,
  //     "installers",
  //   );
  // }

  uploadImage(id,logo, name): Promise<any>{
    const path = `installers/${id}/${name}`;
    const storage = getStorage();
    const storageRef = ref(storage, path);
    const metadata = {
      contentType: 'image/png',
    };
    // 'file' comes from the Blob or File API
    // console.log("path", path)
    // console.log("logo", logo)
    return uploadString(storageRef, logo, 'data_url').then(res=>{
      return getDownloadURL(res.ref);
    })
  }

  createId(){
    return doc(collection(this.firestore, 'id')).id;
     //.createId();
   }

}

